/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';

export const TOGGLE_GLOBAL_SEARCH   = 'TOGGLE_GLOBAL_SEARCH';
export const SET_GLOBAL_SEARCH_TEXT = 'SET_GLOBAL_SEARCH_TEXT';

// It will toggle GlobalSearch dialog
export const toggleGlobalSearch = (value: boolean) => {
  return {type: TOGGLE_GLOBAL_SEARCH, value};
};

// It will set GlobalSearch keyword and module
export const setGlobalSearch = (keyword: string, module: string) => {
  return async(dispatch, getState) => {
    dispatch({type: SET_GLOBAL_SEARCH_TEXT, keyword, module});
  };
};

export interface GlobalSearchState {
  search: {
    isViewing: boolean;
  };
  searchKeyword: String;
  searchModule: String;
}

// defines the initial state for the reducer ...
export const initialState: GlobalSearchState = {
  search : {
    isViewing : false
  },
  searchModule  : '',
  searchKeyword : ''
};

// defines this reducer functions ...
const reducers = {
  [TOGGLE_GLOBAL_SEARCH] : ({search}: GlobalSearchState, {value}) => {
    search.isViewing = value;
  },
  [SET_GLOBAL_SEARCH_TEXT] : (draft: GlobalSearchState, {keyword, module}) => {
    draft.searchModule           = module;
    draft.searchKeyword          = keyword;
  }
};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: GlobalSearchState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
